<template>
    <v-container>
        <v-row>
            <v-col cols="12">
                <div class="services-heading">
                    <h2 class="bf600 pb-5">Services</h2>
                </div>
                <v-card flat class="services">
                    <v-card-text>
                        <v-data-table :headers="tableHeaders" :items="tableList" :itemsPerPage="itemsPerPage"
                            hide-default-footer>
                            <template v-slot:bottom>
                                <div class="v-dt-footer">
                                    <v-btn variant="text" color="secondary">
                                        <v-icon icon="mdi-plus"></v-icon>
                                        Add
                                    </v-btn>
                                    <v-btn variant="text" color="secondary">
                                        <v-icon icon="mdi-plus"></v-icon>
                                        Exit
                                    </v-btn>
                                </div>
                            </template>
                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script setup>
import { ref } from "vue";

let getImgUrl = (pic) => {
    return require("@/assets/image/" + pic);
};

let itemsPerPage = ref(5);
let tableHeaders = ref([
    { title: "Services", key: "services", sortable: false }
]);
let tableList = ref([
    {
        id: 1,
        services: "MECL"
    },
    {
        id: 2,
        services: "MESA"
    },
    {
        id: "3",
        services: "MINA"
    },
    {
        id: "4",
        services: "NCX"
    },
    {
        id: "5",
        services: "NMG"
    },
    {
        id: "6",
        services: "RCI"
    },
    {
        id: "7",
        services: "RKI"
    },
    {
        id: "8",
        services: "SRX"
    }
]);
</script>